import { useAppSelector } from '../hooks';
import { DRAWINGS_FLAG } from '../utils/featureFlagKeys';

/** The Drawings tab and one-step project creation from a drawing (flag `drawings`). */
export const useDrawingsEnabled = (): boolean =>
  useAppSelector((s) => s.featureFlags.userFeatureFlags.includes(DRAWINGS_FLAG));
